module.exports = __webpack_public_path__ + "assets/img/warrior-name-6b1709fb.png";